import styles from './SearchBox.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@casops/store/hooks';
import { selectGridData, setSearch } from '@casops/store/slices/gridSlice';
import { VdsIconButton } from '@volt/volt-extended-components-react';
import VdsBasicInputSafe from '@cas/components/vds-basic-input-safe/VdsBasicInputSafe';
import { useCallback } from 'react';
import type { VdsBasicInputCustomEvent } from '@volt/volt-basic-components/dist/types';

interface SearchBoxProps {
  sliceKey: string;
}

export function SearchBox({ sliceKey }: SearchBoxProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const gridState = useAppSelector(state => selectGridData(state, sliceKey));

  const onSearchChanged = useCallback(
    ({ detail }: VdsBasicInputCustomEvent<string>) => {
      dispatch(setSearch({ id: sliceKey, search: detail }));
    },
    [dispatch, sliceKey],
  );

  return (
    <VdsBasicInputSafe
      id={sliceKey}
      className={styles.search_box}
      placeholder={t('Search')}
      value={gridState?.search}
      onChangeInput={onSearchChanged}
    >
      <VdsIconButton
        slot="secondaryActionIcon"
        icon="zoom-generic"
        variant="secondary"
        size="medium"
      />
    </VdsBasicInputSafe>
  );
}

export default SearchBox;
